module.exports = __webpack_public_path__ + "static/media/adult.65b4f878.png";